module.exports = __webpack_public_path__ + "img/detail-arrow.fe3bbb4a.svg";